var map = {
	"./br/main.yml": 45,
	"./ca/main.yml": 46,
	"./de/main.yml": 47,
	"./en/main.yml": 48,
	"./es/main.yml": 49,
	"./fr/main.yml": 50,
	"./gl/main.yml": 51,
	"./hr/main.yml": 52,
	"./it/main.yml": 53,
	"./oc/main.yml": 54,
	"./pt_BR/main.yml": 55,
	"./uk/main.yml": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 187;